// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 797 ? "ac99ac71" : chunkId) + "." + {"407":"b4b817cf7d3cf2f4","797":"61e1056094ce7035"}[chunkId] + ".js";
};